import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { P } from '../../theme/tokens';
import { HeadIcon, HeadTitle } from './styled';

export const CLOSE_ICON = <FontAwesomeIcon icon={faXmark} style={{ color: P.white, fontSize: 15, opacity: 0.8 }} />;
export const CLOSE_ICON_LG = <FontAwesomeIcon icon={faXmark} style={{ color: P.white, fontSize: 16, opacity: 0.8 }} />;

export function ModalTitle({ title, subtitle, form, eyebrow, icon, size, children }) {
  const text = (
    <div>
      {eyebrow && <small>{eyebrow}</small>}
      <h2>{title}</h2>
      <p>{subtitle}</p>
    </div>
  );
  return (
    <HeadTitle $form={form} $eyebrow={Boolean(eyebrow)} $icon={Boolean(icon)} $size={size}>
      {icon ? (
        <HeadIcon>
          <span>{icon}</span>
          {text}
        </HeadIcon>
      ) : (
        text
      )}
      {children}
    </HeadTitle>
  );
}
